import
{
    Component,
    OnInit
}
    from '@angular/core';
import
{
    GlobalsService
}
    from '../globals.service';
import { AccessGroup, AccessLevel } from '../settings';

@Component(
    {
        selector: 'app-footer',
        templateUrl: './footer.component.html',
        styleUrls: ['./footer.component.css']
    })
export class FooterComponent implements OnInit
{

    constructor(private globals: GlobalsService)
    { }

    ngOnInit()
    { }

    onResized(event)
    {
        this.globals.globalEvents.emit('resize');
    }

    hasAccountSupportAccess()
    {
        return (this.globals.permitSingle(AccessGroup.account, AccessLevel.VIEW_L2));
    }
}